// Hyper-Local SEO configuration for BTC Kokrajhar dominance
export const seoConfig = {
  defaultTitle: 'Roots of Northeast - #Most innovative IT Company in BTC Kokrajhar & Northeast India | ERP & AI Solutions',
  defaultDescription: '🏆 Top IT Company in BTC Kokrajhar & Northeast India. Roots of Northeast - Leading provider of ERP systems, AI attendance management, facial recognition & RFID solutions. Serving 17+ institutions across Assam, Meghalaya, Manipur, Tripura. 99.9% uptime guarantee.',
  defaultKeywords: 'RONE, Roots of Northeast, IT company BTC, IT company Kokrajhar, best IT company Northeast India, ERP systems BTC, school management software Kokrajhar, AI attendance system Assam, facial recognition Bodoland, RFID solutions Northeast, educational technology BTC, software company Kokrajhar, IT services Assam, digital transformation Northeast India, school ERP Kokrajhar, college management system BTC, student information system Northeast, attendance management Assam, cloud solutions Kokrajhar, custom software development BTC, web development Northeast India, mobile app development Kokrajhar, e-governance solutions BTC, smart classroom technology Northeast, educational software Assam, IT consulting Kokrajhar, software development company BTC, technology solutions Northeast India',
  siteUrl: 'https://rotsofnortheast.com',
  company: 'Roots of Northeast',
  brandName: 'Roots of Northeast',
  logo: 'https://rootsofnortheast.com/new_logo.png',
  ogImage: '/og-image-local-seo.png',
  location: {
    city: 'Kokrajhar',
    state: 'Assam',
    region: 'BTC (Bodoland Territorial Council)',
    country: 'India',
    coordinates: {
      latitude: '26.4019',
      longitude: '90.2715'
    },
    serviceArea: ['BTC', 'Kokrajhar', 'Assam', 'Meghalaya', 'Manipur', 'Tripura', 'Nagaland', 'Mizoram', 'Arunachal Pradesh']
  }
};

export const generateOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://rootsofnortheast.com#organization",
  "name": "RONE - Roots of Northeast",
  "legalName": "Roots of Northeast (RONE)",
  "alternateName": ["RONE", "Roots of Northeast", "Roots of Northeast"],
  "url": "https://rotsnortheast.com",
  "logo": "https://rotsnortheast.com/new_logo.png",
  "description": "#1 IT Company in BTC Kokrajhar and Northeast India. Leading provider of ERP systems, AI-powered attendance management, facial recognition, and RFID solutions for educational institutions across Northeast India.",
  "slogan": "Northeast India's Premier IT Solutions Provider",
  "brand": {
    "@type": "Brand",
    "name": "RONE",
    "logo": "https://rotsnortheast.com/new_logo.png"
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Technology Hub, Kokrajhar",
    "addressLocality": "Kokrajhar",
    "addressRegion": "BTC, Assam",
    "postalCode": "783370",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "26.4019",
    "longitude": "90.2715"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+91-91016-33479",
      "contactType": "customer service",
      "areaServed": ["BTC", "Kokrajhar", "Assam", "Northeast India"],
      "availableLanguage": ["English", "Hindi", "Assamese", "Bodo"]
    },
    {
      "@type": "ContactPoint",
      "email": "info@rotsnortheast.com",
      "contactType": "customer support"
    }
  ],
  "areaServed": [
    {
      "@type": "AdministrativeArea",
      "name": "Bodoland Territorial Council (BTC)"
    },
    {
      "@type": "City",
      "name": "Kokrajhar"
    },
    {
      "@type": "State",
      "name": "Assam"
    },
    {
      "@type": "Country",
      "name": "Northeast India"
    }
  ],
  "sameAs": [
    "https://www.linkedin.com/company/rone-rots-northeast",
    "https://twitter.com/rone_northeast",
    "https://www.facebook.com/rone.northeast",
    "https://www.instagram.com/rone_northeast",
    "https://www.youtube.com/c/ronenortheast"
  ],
  "foundingDate": "2019",
  "numberOfEmployees": "13",
  "industry": "Information Technology",
  "keywords": "RONE, IT company BTC, IT company Kokrajhar, best IT company Northeast India, ERP systems, AI technology, facial recognition, RFID attendance, educational technology",
  "knowsAbout": ["ERP Systems", "AI Technology", "Facial Recognition", "RFID Solutions", "Educational Technology", "Software Development", "Cloud Computing", "Digital Transformation"],
  "award": ["Best IT Company Northeast India 2023", "Excellence in Educational Technology 2024", "Top Software Company BTC 2023"],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "hasCredential": {
    "@type": "EducationalOccupationalCredential",
    "credentialCategory": "ISO 9001:2015 Certified"
  }
});

export const generateServiceSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "ERP Systems & AI Technology Solutions",
  "provider": {
    "@type": "Organization",
    "name": "Roots of Northeast"
  },
  "description": "Comprehensive ERP systems, AI-powered attendance management, facial recognition technology, and RFID solutions for educational institutions.",
  "serviceType": "Technology Solutions",
  "areaServed": "Northeast India",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Technology Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "ERP Systems",
          "description": "Complete enterprise resource planning solutions for educational institutions"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "AI Attendance Management",
          "description": "Facial recognition and AI-powered attendance tracking systems"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "RFID Solutions",
          "description": "Advanced RFID attendance systems with 12-meter range capability"
        }
      }
    ]
  }
});

export const generateBreadcrumbSchema = (breadcrumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": crumb.name,
    "item": `https://rootsofnortheast.com${crumb.url}`
  }))
});

export const generateFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const generateProductSchema = (product) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": product.name,
  "description": product.description,
  "brand": {
    "@type": "Brand",
    "name": "Roots of Northeast"
  },
  "manufacturer": {
    "@type": "Organization",
    "name": "Roots of Northeast"
  },
  "category": "Software",
  "offers": {
    "@type": "Offer",
    "description": product.description,
    "seller": {
      "@type": "Organization",
      "name": "Roots of Northeast"
    }
  }
});